<template>
  <div class="mul-content">
    <div class="left">
      <div v-for="(item, index) in data" :key="index" class="option-item">
        <div
          :class="{
            'fir-option-item': true,
            focus: currentFirst === item.clinic_no && !item.children.length,
          }"
          @click="onClick(item)"
        >
          <span>{{ item.clinic_name }}</span>
          <img
            v-if="item.children.length"
            src="https://staff.chunyu.mobi/@/media/images/2021/12/30/1c45/905378fed613_w27_h18_.png"
            alt="下"
            :class="{ focus: currentFirst === item.clinic_no }"
          />
        </div>
        <div
          v-for="(e, i) in item.children"
          :key="i"
          :class="{
            'sec-option-item': true,
            hide: item.clinic_no !== currentFirst,
            fouce: e.clinic_no === currentSecond,
          }"
          @click="onClickSec(e)"
        >
          {{ e.clinic_name }}
        </div>
      </div>
    </div>
    <div class="right">
      <div
        v-for="(item, index) in currentDisList"
        :key="index"
        class="dis-item"
        @click="onDis(item)"
      >
        {{ item.name }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'MultisSelect',
  props: {
    data: {
      // 被渲染的三级列表
      type: Array,
      default: () => [],
    },
  },
  data: () => {
    return {
      currentFirst: '', // 第一级被选择的值
      currentSecond: '', // 第二级被选择的值
      currentDis: '', // 选择的药品
      currentDisList: [], // 需展示的药品列表
    };
  },
  // created() {
  //   console.log(this.data);
  // },
  methods: {
    /**
     * 一级科室点击事件
     *
     * @param {object} item 当前被点击的元素
     */
    onClick(item) {
      if (item.clinic_no === this.currentFirst) {
        this.currentFirst = '';
        return;
      }
      if (item.disease_list.length) {
        this.currentDisList = item.disease_list;
      }
      this.currentFirst = item.clinic_no;
    },
    /**
     * 二级科室点击事件
     *
     * @param {object} item 当前被点击的元素
     */
    onClickSec(item) {
      this.currentSecond = item.clinic_no;
      if (item.disease_list.length) {
        this.currentDisList = item.disease_list;
      }
    },
    /**
     * 选中事件
     *
     * @param {object} item 被选择的值
     */
    onDis(item) {
      this.$emit('onChange', item.name);
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@@/styles/mixin.scss';
.hide {
  display: none;
}
.mul-content {
  display: flex;
}
.left,
.right {
  width: 50%;
  max-height: rem(360);
  overflow: auto;
}
.option-item {
  div {
    height: rem(40);
    // padding-left: rem(16);
    padding: 0 rem(16);
    font-size: rem(15);
    line-height: rem(40);
    text-align: left;
    background: #f4f4f4;
  }
  .sec-option-item {
    background: #eee;
  }
  .fouce.sec-option-item {
    color: #39d167;
    background: #fff;
  }
}
.fir-option-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  img {
    width: rem(5.5);
  }
  img.focus {
    transform: rotate(180deg);
  }
}
.fir-option-item.focus {
  color: #39d167;
  background: #fff;
}
.right {
  padding-left: rem(15);
}
.dis-item {
  height: rem(40);
  padding-right: rem(5);
  overflow: hidden;
  line-height: rem(40);
  white-space: nowrap;
  text-align: left;
  text-overflow: ellipsis;
  border-bottom: rem(0.5) solid #f4f4f4;
}
</style>
